import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-faculty-attendance',
  templateUrl: './faculty-attendance.component.html',
  styleUrls: ['./faculty-attendance.component.scss']
})
export class FacultyAttendanceComponent implements OnInit {

  constructor(private dataService: DataService) { }
  loading:any = false;
  data:any = {list:[], count:0};
  date:any = "";
  today:any = "";
  attendance:any = [];
  isHoliday:any = false;
  limit:any = 50;
  offset:any = 0;
  search:any = "";

  ngOnInit(): void {
    this.date = new Date();
    this.today = new Date();

    this.loadFaculties();
    this.loadAttendance();
  }

  loadFaculties(){
    this.dataService.getFaculties(this.limit, this.offset, this.search).subscribe( (data: any )=> {
      if(data.status == 0){
        this.data = data;
      }
    } );
  }

  

  paginate(dir){
    if(dir == 2) {
      this.offset += this.limit;
    } else {
      this.offset -= this.limit;
      if(this.offset < 0){
        this.offset = 0;
      }
    }

    this.loadFaculties();

  }



  formattedDate(date){
    const year = date.getFullYear();
    // Month is zero-indexed, so we add 1 to get the actual month
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Format the date as a string (optional)
    //const formattedDate = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`; //d-m-Y
    const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`; //Y-m-d

    return formattedDate;
  }

  setCustomDate(date){
    this.date = new Date(date);
    this.loadAttendance();
  }

  forwardDate(){
    const nextDate = new Date(this.date);
    nextDate.setDate(nextDate.getDate() + 1);
    this.date = nextDate;
    this.loadAttendance();
  }

  backwardDate(){
    const previousDate = new Date(this.date);
    previousDate.setDate(previousDate.getDate() - 1);
    this.date = previousDate;
    this.loadAttendance();
  }

  loadAttendance(){
    this.attendance = [];
    this.dataService.getFacultyAttendance(this.formattedDate(this.date)).subscribe( (data: any )=> {
      if(data.status == 0){
        this.attendance = data.data;
        this.isHoliday = data.isHoliday;
      }
    } );
  }

  markAttendance(facultyId, attendance){

    if (!this.attendance[facultyId]) {
      this.attendance[facultyId] = {}; // Create an empty object if it doesn't exist
    }

    let data = {
      faculty_id:facultyId,
      attendance:attendance,
      date: this.formattedDate(this.date),
      
    }
    this.attendance[facultyId] = attendance;
    this.loading = true;
    this.dataService.postFacultyAttendance(data).subscribe( (res:any) => {
      this.loading = false;
      if(res.status == 0) {
        //
      } else {
        alert(res.msg);
      }

    });
  }

}
